import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'

/* Layout */
import Layout from '../layout'

import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

Vue.use(VueRouter)

/**
 * 定义所有路由
 */
export const constantRouterMap = [
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  {
    path: '/register',
    component: () => import('@/views/login/register'),
    hidden: true
  },
  {
    path: '/forget',
    component: () => import('@/views/login/forget'),
    hidden: true
  },
  {
    path: '/demo',
    component: () => import('@/views/login/demo'),
    hidden: true
  },
  {
    path: '/404',
    component: () => import('@/views/404'),
    hidden: true
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [
      {
        path: '/dashboard',
        name: 'Dashboard',
        component: () => import('@/views/dashboard'),
        meta: { title: '首页', icon: 'icon-dashboard' }
      }
    ],
    hidden: true
  },
  {
    path: '/activityManager/myActivities/import-entry',
    component: () => import('@/views/activityManager/myActivities/import-entry.vue'),
    name: 'import-entry',
    meta: { title: '导入数据' },
    hidden: true
  },
  {
    path: '/activityManager',
    component: Layout,
    redirect: '/activityManager/myActivities',
    meta: { title: '活动管理', icon: 'icon-dashboard' },
    children: [
      {
        path: '/activityManager/myActivities',
        name: 'myActivities',
        component: () => import('@/views/activityManager/myActivities/index.vue'),
        meta: { title: '我的活动', icon: 'icon-dashboard' }
      },
      {
        path: '/activityManager/myActivities/activityProgress',
        name: 'activity-progress',
        component: () => import('@/views/activityManager/myActivities/activityProgress/index.vue'),
        meta: { title: '报名数据', icon: 'icon-dashboard' },
        hidden: true
      },
      {
        path: '/activityManager/myActivities/giftsAndPrizes',
        name: 'giftsAndPrizes',
        component: () => import('@/views/activityManager/myActivities/giftsAndPrizes/index.vue'),
        meta: { title: '礼品与奖品' },
        hidden: true
      },
      {
        path: '/activityManager/myActivities/quickMark',
        name: 'quickMark',
        component: () => import('@/views/activityManager/myActivities/quickMark/index.vue'),
        meta: { title: '签到码管理' },
        hidden: true
      }
    ]
  },
  {
    path: '/rankingManagement/likeRanking',
    redirect: '/rankManagement/likeRanking',
    hidden: true
  }
]

/**
 * 创建路由对象
 */
const router = new VueRouter({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})

// 路径缓存
export let cachePaths = {}

const REVIEW_MANAGEMENT_MENU_TITLE = '评选管理'
const ELECTRONIC_DIPLOMA_MENU_PATH = '/electronicDiploma'

function isElectronicDiplomaMenuRoute (route) {
  return (
    route.path === ELECTRONIC_DIPLOMA_MENU_PATH ||
    (route.meta && route.meta.title === '电子奖状')
  )
}

/** 将目标菜单固定在 anchorTitle 下一项（侧栏自上而下顺序） */
function placeMenuRouteAfter (routes, anchorTitle, matchRoute) {
  const list = routes.slice()
  const targetIdx = list.findIndex(matchRoute)
  if (targetIdx < 0) return routes
  const [target] = list.splice(targetIdx, 1)
  const anchorIdx = list.findIndex((r) => r.meta && r.meta.title === anchorTitle)
  if (anchorIdx < 0) {
    list.splice(targetIdx, 0, target)
    return list
  }
  list.splice(anchorIdx + 1, 0, target)
  return list
}

/** 评选管理下旧「奖项模板」菜单（已由「电子奖状 → 奖状模板」替代） */
const LEGACY_AWARD_TEMPLATE_MENU_TITLES = new Set(['奖项模板', '奖项模板管理'])

function isLegacyAwardTemplateMenuItem (item) {
  if (!item) return false
  const title = (item.meta && item.meta.title) || item.title || ''
  if (LEGACY_AWARD_TEMPLATE_MENU_TITLES.has(title)) return true
  const path = String(item.path || '').toLowerCase()
  if (path.includes('/electronicdiploma')) return false
  if (
    path.includes('/evaluation') &&
    (path.includes('rank-template') || path.includes('ranktemplate'))
  ) {
    return true
  }
  return false
}

function filterLegacyAwardTemplateFromMenus (routes) {
  return routes
    .filter((route) => !isLegacyAwardTemplateMenuItem(route))
    .map((route) => {
      if (!route.children || !route.children.length) return route
      return {
        ...route,
        children: route.children.filter((child) => !isLegacyAwardTemplateMenuItem(child))
      }
    })
}

/**
 * 不重定向白名单
 * 包含不需要登录即可访问的页面（如导入报名数据页面，通过手机验证控制访问）
 */
const whiteList = ['/404', '/login', '/register', '/forget', '/demo', '/activityManager/myActivities/import-entry']
/**
 * 设置路由钩子，控制权限逻辑
 */
// 导航锁，防止重复导航
let isNavigating = false

router.beforeEach((to, from, next) => {
  // 如果已经在导航中，且目标路径是登录页，直接放行
  if (isNavigating && to.path === '/login') {
    isNavigating = false
    next()
    return
  }
  
  // 如果已经在导航到登录页，且当前也是导航到登录页，直接放行
  if (isNavigating && from.path !== '/login' && to.path === '/login') {
    isNavigating = false
    next()
    return
  }
  
  // 如果从登录页导航到其他页面（登录成功后跳转），重置导航标志
  if (isNavigating && from.path === '/login' && to.path !== '/login') {
    isNavigating = false
  }
  
  NProgress.start()
  // 判断是否有 token
  if (!store.getters.token) {
    if (whiteList.indexOf(to.path) !== -1) {
      isNavigating = false
      next()
    } else {
      // 如果已经在登录页，直接放行
      if (to.path === '/login') {
        isNavigating = false
        NProgress.done()
        next()
        return
      }
      
      let query = {
        redirect: to.path
      }
      if (to.query) {
        query = Object.assign(query, to.query)
      }
      isNavigating = true
      next({
        path: '/login',
        query,
        replace: true
      })
      NProgress.done()
    }
  } else {
    // 如果有 token 拉取用户权限
    if (store.getters.menus === null) {
      // 菜单 / 权限 / 商户信息 / OSS 域名 任一失败不应整批失败（否则侧栏为空且控制台报 5000）
      ;(async () => {
        let userMenu = []
        try {
          const m = await store.dispatch('MerchantMe/getMenus')
          userMenu = Array.isArray(m) ? m : []
        } catch (e) {
          store.commit('MerchantMe/SET_MENUS', [])
          userMenu = []
        }

        try {
          await store.dispatch('MerchantMe/getPermissions')
        } catch (e) {
          store.commit('MerchantMe/SET_PERMISSIONS', {})
        }

        try {
          await store.dispatch('MerchantMe/getMerchantInfo')
        } catch (e) {}

        try {
          await store.dispatch('MerchantOssUpload/getPublicDataHost')
        } catch (e) {}
        
        try {
          // 标准化后端菜单路径，避免出现 "views/xxx" 或缺少前导 "/" 导致路由异常
          const normalizeRoutePath = (rawPath) => {
            if (!rawPath) return ''
            let p = String(rawPath).trim()
            if (!p.startsWith('/')) {
              p = `/${p}`
            }
            return p
          }
          const normalizeViewPath = (rawPath) => {
            if (!rawPath) return ''
            let p = String(rawPath).trim()
            p = p.replace(/^\/?views/, '')
            if (!p.startsWith('/')) {
              p = `/${p}`
            }
            return p
          }
          // 树状菜单：根节点必须与 userMenuMap 中对象为同一引用。
          // 原先 rootMenu.push({ ...item }) 为浅拷贝，子节点挂在 map 原对象上，导致 rootMenu 里每个根的 children 始终为空，侧栏只剩合并进来的静态项。
          const isMenuRootParentId = (pid) => {
            if (pid === -1 || pid === '-1') return true
            if (pid === 0 || pid === '0') return true
            if (pid == null) return true
            return false
          }
          const resolveMenuIcon = (title, icon) => {
            if (title === '排行榜管理') return 'dzs-icon'
            if (title === '点赞榜') return 'evaluation-rank-mgr'
            if (title === '电子奖状' || title === '奖状模板' || title === '颁发奖状') return 'evaluation-rank-mgr'
            return icon || 'icon-dashboard'
          }
          const rootMenu = []
          const userMenuMap = {}
          userMenu.forEach((item) => {
            userMenuMap[item.id] = item
            item.children = []
          })
          userMenu.forEach((item) => {
            const pid = item.parentId
            if (isMenuRootParentId(pid)) {
              rootMenu.push(item)
            } else {
              const parentItem = userMenuMap[pid]
              if (parentItem) {
                parentItem.children.push(item)
                item.parent = parentItem
              } else {
                // 父节点缺失时仍作为根展示，避免整段菜单被丢弃
                rootMenu.push(item)
              }
            }
          })
          let menuRoutes = []
          if (rootMenu && rootMenu.length > 0) {
            rootMenu.forEach((menu) => {
              const menuRouter = {
                name: menu.name,
                component: Layout,
                path: normalizeRoutePath(menu.path),
                meta: { title: menu.title, icon: menu.icon || 'icon-dashboard' },
                children: [],
                alwaysShow: true,
                sortBy: menu.sortBy
              }
              if (menu['children'] && menu['children'].length > 0) {
                menu['children'].forEach((submenu) => {
                  if (isLegacyAwardTemplateMenuItem(submenu)) return
                  menuRouter.children.push({
                    name: submenu.name,
                    path: normalizeRoutePath(submenu.path),
                    component: () => import(`@/views${normalizeViewPath(submenu.path)}`),
                    meta: { title: submenu.title, icon: submenu.icon || 'icon-dashboard' },
                    sortBy: submenu.sortBy
                  })
                })
              }
              menuRoutes.push(menuRouter)
            })
          }

          menuRoutes = filterLegacyAwardTemplateFromMenus(menuRoutes)

          // 排序（sortBy 可能为 undefined / 字符串）
          const sortFn = (a, b) => {
            return Number(b.sortBy || 0) - Number(a.sortBy || 0)
          }
          menuRoutes = menuRoutes.sort(sortFn)

          menuRoutes.forEach((menuRouter) => {
            if (menuRouter['children'] && menuRouter['children'].length > 0) {
              menuRouter['children'] = menuRouter['children'].sort(sortFn)
            }
          })

          const newMenuRoutes = []
          // 先收集 menuRoutes 中已有的路由名称，用于合并时去重
          const menuRouteNames = new Set()
          menuRoutes.forEach((route) => {
            if (route.name) {
              menuRouteNames.add(route.name)
            }
            if (route.children) {
              route.children.forEach((child) => {
                if (child.name) {
                  menuRouteNames.add(child.name)
                }
              })
            }
          })
          
          // 将 constantRouterMap 中的静态 Layout 菜单合并到侧栏（仅活动管理，其余菜单走后端）
          const mergeConstantLayoutMenu = (layoutPath, defaultSortBy) => {
            const layoutItem = constantRouterMap.find((route) => route.path === layoutPath)
            if (!layoutItem || !layoutItem.children) return
            const existing = menuRoutes.find((route) => route.path === layoutPath)
            if (existing) {
              const existingChildren = existing.children || []
              layoutItem.children.forEach((constantChild) => {
                const exists =
                  existingChildren.find(
                    (child) =>
                      child.path === constantChild.path ||
                      (child.name && constantChild.name && child.name === constantChild.name)
                  ) || (constantChild.name && menuRouteNames.has(constantChild.name))
                if (!exists) {
                  existingChildren.push(constantChild)
                  if (constantChild.name) {
                    menuRouteNames.add(constantChild.name)
                  }
                }
              })
              existing.children = existingChildren.sort(sortFn)
              existing.alwaysShow = true
              if (defaultSortBy != null) {
                existing.sortBy = defaultSortBy
              }
              if (existing.meta && layoutItem.meta && layoutItem.meta.icon) {
                existing.meta.icon = resolveMenuIcon(existing.meta.title, layoutItem.meta.icon)
              }
            } else {
              menuRoutes.push({
                ...layoutItem,
                children: layoutItem.children,
                alwaysShow: true,
                sortBy: defaultSortBy
              })
            }
          }
          mergeConstantLayoutMenu('/activityManager', 999)

          // 保留 hidden 静态路由（登录/注册/404/旧路径重定向等），不参与侧栏
          constantRouterMap.forEach((item) => {
            if (item.hidden) {
              newMenuRoutes.push(item)
            }
          })
          
          // 重新排序，确保活动管理菜单正确显示
          menuRoutes = menuRoutes.sort(sortFn)
          // 电子奖状固定在「评选管理」正下方（避免 sortBy 与其它菜单冲突）
          menuRoutes = placeMenuRouteAfter(
            menuRoutes,
            REVIEW_MANAGEMENT_MENU_TITLE,
            isElectronicDiplomaMenuRoute
          )
          
          // 先收集所有已有的路由名称（包括 constantRouterMap、router.options.routes 和 menuRoutes 中的）
          const existingRouteNames = new Set()
          // 收集 constantRouterMap 中的路由名称
          constantRouterMap.forEach((item) => {
            if (item.name) {
              existingRouteNames.add(item.name)
            }
            if (item.children) {
              item.children.forEach((child) => {
                if (child.name) {
                  existingRouteNames.add(child.name)
                }
              })
            }
          })
          // 收集 router.options.routes 中已有的路由名称
          router.options.routes.forEach((item) => {
            if (item.name) {
              existingRouteNames.add(item.name)
            }
            if (item.children) {
              item.children.forEach((child) => {
                if (child.name) {
                  existingRouteNames.add(child.name)
                }
              })
            }
          })
          
          // 路由 name 在 Vue Router 中须唯一；与 constantRouterMap 重名时曾直接丢弃整段后端菜单，导致侧栏只剩少数项。
          // 改为在冲突时按 path 生成唯一 name，保留全部菜单。
          const routeNameSet = new Set(existingRouteNames)
          const ensureUniqueRouteName = (route) => {
            if (!route) return
            if (route.name) {
              const orig = String(route.name)
              let name = orig
              if (routeNameSet.has(name)) {
                const suffix = String(route.path || '')
                  .replace(/[^a-zA-Z0-9]+/g, '_')
                  .replace(/^_|_$/g, '') || 'route'
                let candidate = `${orig}__${suffix}`
                let i = 0
                while (routeNameSet.has(candidate)) {
                  i += 1
                  candidate = `${orig}__${suffix}_${i}`
                }
                name = candidate
                route.name = name
              }
              routeNameSet.add(name)
            }
            if (route.children && route.children.length > 0) {
              route.children.forEach((child) => ensureUniqueRouteName(child))
            }
          }
          const deduplicatedMenuRoutes = []
          menuRoutes.forEach((item) => {
            ensureUniqueRouteName(item)
            deduplicatedMenuRoutes.push(item)
          })
          
          deduplicatedMenuRoutes.forEach((item) => {
            newMenuRoutes.push(item)
          })
          router.options.routes = newMenuRoutes
          // 使用 addRoute 逐个添加路由，避免 addRoutes 的弃用警告
          deduplicatedMenuRoutes.forEach((route) => {
            router.addRoute(route)
          })
          // 缓存所有路径为以后判断使用
          cachePaths = {}
          // 先添加 constantRouterMap 中的所有路由（包括 import-entry）
          constantRouterMap.forEach((item) => {
            cachePaths[item.path] = true
            if (item.children) {
              item.children.forEach((subitem) => {
                cachePaths[subitem.path] = true
              })
            }
          })
          // 再添加动态菜单路由
          router.options.routes.forEach((item) => {
            cachePaths[item.path] = true
            if (item.children) {
              item.children.forEach((subitem) => {
                cachePaths[subitem.path] = true
              })
            }
          })
          if (cachePaths[to.path]) {
            isNavigating = false
            next({ ...to, replace: true })
          } else {
            isNavigating = false
            next('/')
          }
        } catch (buildErr) {
          if (process.env.NODE_ENV !== 'production') {
            // eslint-disable-next-line no-console
            console.error('路由动态注册失败:', buildErr)
          }
          if (store.getters.menus === null) {
            store.commit('MerchantMe/SET_MENUS', [])
          }
          isNavigating = false
          next({ path: '/', replace: true })
          NProgress.done()
        }
      })()
    } else {
      // 即使 menus 不为 null，也检查是否需要更新 merchantInfo（切换账号时）
      // 如果 merchantInfo 为空，主动获取并等待完成
      if (!store.getters.merchantInfo) {
        store.dispatch('MerchantMe/getMerchantInfo').then(() => {
          // 等待一个 tick，确保组件能响应数据变化
          Vue.nextTick(() => {
            isNavigating = false
            next()
          })
        }).catch(() => {
          isNavigating = false
          next()
        })
      } else {
        // merchantInfo 存在时，也尝试刷新一次，确保数据是最新的
        // 但不要阻塞路由跳转
        store.dispatch('MerchantMe/getMerchantInfo').catch(() => {
          // 静默失败，不影响路由跳转
        })
        isNavigating = false
        next()
      }
    }
  }
})

router.afterEach((to, from) => {
  NProgress.done() // 结束Progress
  // 重置导航锁
  isNavigating = false
  // 路由跳转后，如果 merchantInfo 为空，尝试获取
  // 这样可以确保切换账号后标题能正确显示
  if (store.getters.token && !store.getters.merchantInfo) {
    store.dispatch('MerchantMe/getMerchantInfo').catch(() => {
      // 静默失败
    })
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js